import { ReactNode } from 'react';
import { BannerContainer } from './Banner.styles';

export type BannerProps = {
	variant: 'primary' | 'info';
	children?: ReactNode;
};

function Banner(props: BannerProps) {
	const { variant, children } = props;

	return <BannerContainer variant={variant}>{children}</BannerContainer>;
}

export { Banner };
